export default theme => ({
	flagButton: {
		marginRight: 10,
	},
});
